import {createAction} from "@reduxjs/toolkit";
import {Product} from "../api/GovernanceToolApi";

export const updateLastSearchResultAction =
    createAction('updateLastSearchResult', function prepare(products: Product[] | null | undefined, count: number | undefined) {
        return {
            payload: {
                products,
                count
            },
        }
    })